import * as React from "react";

const SiteTypeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      fill="#000"
      d="M13.634 11.667c.066-.55.116-1.1.116-1.667s-.05-1.117-.116-1.667h2.816c.134.534.217 1.092.217 1.667s-.083 1.133-.217 1.667M12.16 16.3c.5-.925.883-1.925 1.15-2.967h2.458a6.7 6.7 0 0 1-3.608 2.967m-.209-4.633h-3.9c-.083-.55-.133-1.1-.133-1.667s.05-1.125.133-1.667h3.9c.075.542.134 1.1.134 1.667s-.059 1.117-.134 1.667M10 16.633c-.691-1-1.25-2.108-1.591-3.3h3.183c-.342 1.192-.9 2.3-1.592 3.3M6.667 6.667H4.234a6.6 6.6 0 0 1 3.6-2.967c-.5.925-.875 1.925-1.167 2.967m-2.433 6.666h2.433c.292 1.042.667 2.042 1.167 2.967a6.67 6.67 0 0 1-3.6-2.967m-.684-1.666A7 7 0 0 1 3.334 10c0-.575.083-1.133.216-1.667h2.817c-.067.55-.117 1.1-.117 1.667s.05 1.117.117 1.667M10 3.358c.692 1 1.25 2.117 1.592 3.309H8.409A11.4 11.4 0 0 1 10 3.358m5.767 3.309h-2.458a13 13 0 0 0-1.15-2.967 6.66 6.66 0 0 1 3.608 2.967m-5.767-5c-4.608 0-8.333 3.75-8.333 8.333A8.333 8.333 0 1 0 10 1.667"
    ></path>
  </svg>
);

export default SiteTypeIcon;
